<template>
  <div class="pm-dialog-order-type">
    <div class="flex justify-center outer-area">
      <div class="vs-col candidate-list" v-for="(master,index) in masterList" :key="index" >
        <vs-button
          class="candidate-item"
          :color="(String(selectedId) === String(master.id)) ?
            String(selectedId) === '1' ? '#5286ED' :  
            String(selectedId) === '2' ? '#A8309C' : 
            String(selectedId) === '3' ? '#34A118' : 
            String(selectedId) === '5' ? '#A8309C' : 
            String(selectedId) === '6' ? '#5286ED' : 
            '#4F4F4F' : '#bdbdbd'"
          @mousedown="selectedId = master.id"
        >
          {{ master.value }}
        </vs-button>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button 
        :color="selectedId ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="selectedId ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      selectedId: null,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      const sortOrderList = this.masterMap['order_type_sorts'].map(x => x.value);
      let masterList = [];
      for(let sortOrder of sortOrderList ) {
        const orderType = this.masterMap['order_type'].find(x => x.id == sortOrder);
        if ( orderType ) {
          masterList.push(orderType);
        }
      }
      return masterList;
    },
  },
  methods: {
    initData() {
      this.selectedId = this.valueMap ? this.valueMap.id : null; 
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = String(this.selectedId);
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-order-type {
  .outer-area {
    padding: 1rem;
  }
  .candidate-list {
    margin: 0.2rem;
    min-height: 6rem;
  }
  .candidate-item {
    min-width: 5rem;
    padding-left : 0 !important;
    padding-right: 0 !important;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
}
</style>

